import PubSub from "underpub-js";
import gsap from "gsap";
import Cookies from 'js-cookie';

var NewsletterPopup = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-NewsletterPopup',
		isToggled: false,
	};

	$.extend(true, this.options, options);

};

NewsletterPopup.prototype.init = function() {

	var self = this;

	self.$close = self.options.$el.find(`.${self.options.baseClass}__close`);
	self.$csrf = self.options.$el.find(`input[name="CRAFT_CSRF_TOKEN"]`);

	// update CSRF token - otherwise Blitz cache will break the form
	fetch('/actions/blitz/csrf/token')
		.then(result => { return result.text(); })
		.then(text => { 
			self.$csrf.val(text);
			console.log(text);
		});

	self.initAnimation();

	if (self.getHideCookie() !== "true") {

		$(window).on('load', () => {
			gsap.delayedCall(4, () => self.toggleOn())
		});

	}

	self.$close.on('click', () => self.toggleOff());

};

NewsletterPopup.prototype.initAnimation = function () {
	const self = this;

	self.animationTimeline = gsap
		.timeline({
			paused: true,
			reversed: true,
			defaults: {
				ease: "expo.out",
				duration: .65,
			},
			onComplete: () => {
				self.toggleState();
			},
			onReverseComplete: () => {
				self.toggleState();
			},
		})
		.to(self.options.$el, {
			x: 0,
		})
};

NewsletterPopup.prototype.toggleState = function () {
	const self = this;

	self.options.isToggled = !self.options.isToggled;
};

NewsletterPopup.prototype.toggleOn = function (speed = 1) {
	const self = this;

	if (self.options.isToggled || self.animationTimeline.isActive()) return;

	self.animationTimeline.timeScale(speed).play();
};

NewsletterPopup.prototype.toggleOff = function (speed = 1.4) {
	const self = this;

	self.setHideCookie();

	if (!self.options.isToggled || self.animationTimeline.isActive()) return;

	self.animationTimeline.timeScale(speed).reverse();
};

NewsletterPopup.prototype.setHideCookie = function () {
	const self = this;

	const cookieExpiryTime = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);

	Cookies.set("hideNewsletterPopup", "true", {
		expires: cookieExpiryTime,
	});
}

NewsletterPopup.prototype.getHideCookie = function () {
	const self = this;

	return Cookies.get("hideNewsletterPopup");
}

export default NewsletterPopup;
